export const APP_STORE_URL = 'https://apps.apple.com/app/kaziatlas/id6780778250';
